import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { S3Service } from 'src/app/services/health-record/other-documents/s3.service';

@Component({
	selector: 'app-delete-document-modal',
	templateUrl: './delete-document-modal.component.html',
	styleUrls: ['./delete-document-modal.component.scss'],
})
export class DeleteDocumentModalComponent {
	eValue: any;

	constructor(
		public dialogRef: MatDialogRef<DeleteDocumentModalComponent>,
		private s3Service: S3Service,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	onNoClick(): void {
		this.dialogRef.close();
	}

	deleteDocument(key) {
		this.s3Service.deleteObject(key);
	}

	actionFunction(e, documentKey) {
		if (e.value === 'submit') {
			this.deleteDocument(documentKey);
			this.dialogRef.close();
		} else if (e.value === 'cancel') {
			this.dialogRef.close();
		} else {
			this.onNoClick();
		}
	}
}
